import React, { useState, useEffect } from 'react'
import SlideToggle from 'react-slide-toggle'
import { Link } from 'gatsby'
import { serviceCategories } from '../serviceCategories'
import ContactButton from './ContactButton'
import ServiceMenuItem from './ServiceMenuItem'

const getScrollValueFromTop = () => {
  return Math.max(
    window.pageYOffset,
    document.documentElement.scrollTop,
    document.body.scrollTop
  )
}

const isSlideOpen = (toggleState) =>
  toggleState === 'EXPANDED' || toggleState === 'EXPANDING'

const MobileServiceMenuItem = ({ item, onClick }) => {
  const content = (
    <li className={item.listClass ? item.listClass : undefined}>
      {item.icon && (
        <img src={`/assets/images/common/${item.icon}.png`} alt="" />
      )}
      {item.label}
    </li>
  )

  if (item.to) {
    return (
      <Link to={item.to} onClick={onClick}>
        {content}
      </Link>
    )
  }

  if (item.href) {
    if (item.external) {
      return (
        <a href={item.href} target="_blank" rel="noreferrer" onClick={onClick}>
          {content}
        </a>
      )
    }
    return (
      <a href={item.href} onClick={onClick}>
        {content}
      </a>
    )
  }

  return <div className="service-mobile__link--disabled">{content}</div>
}

const Header = () => {
  const [showHeader, setShowHeader] = useState(true)
  const [fixHeader, setFixHeader] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [activeServiceCategory, setActiveServiceCategory] = useState(
    serviceCategories[0].id
  )

  const onScroll = () => {
    const position = getScrollValueFromTop()
    if (position >= 500) {
      setFixHeader(true)
      setTimeout(() => {
        setShowHeader(true)
      }, 50)
    } else {
      setShowHeader(false)
      setTimeout(() => {
        setFixHeader(false)
        setShowHeader(true)
        setShowHeader(false)
      }, 50)
    }
  }

  useEffect(() => {
    document.addEventListener('scroll', onScroll)
    return () => document.removeEventListener('scroll', onScroll)
  })

  const activeCategory =
    serviceCategories.find(
      (category) => category.id === activeServiceCategory
    ) || serviceCategories[0]

  const topLink = activeCategory?.topLink
  const hasTopLinkTarget = !!(
    topLink &&
    typeof topLink.to === 'string' &&
    topLink.to.trim()
  )

  const activateServiceCategory = (categoryId) => {
    setActiveServiceCategory(categoryId)
  }

  const handleSidebarButtonFocus = (event, categoryId) => {
    const { target } = event

    if (typeof target?.matches === 'function') {
      try {
        if (!target.matches(':focus-visible')) {
          return
        }
      } catch (error) {
        // ブラウザが:focus-visible非対応の場合はフォールバックして処理を継続する
      }
    }

    activateServiceCategory(categoryId)
  }
  const handleDrawerItemClick = () => {
    setIsDrawerOpen(false)
  }

  return (
    <header
      className={`${showHeader ? 'show' : ''} ${fixHeader ? 'fixed' : ''}`}
    >
      <div className="header-wrapper clearfix">
        <Link className="logo" to={`/`}>
          <img src="/assets/images/common/logo-rgb.png" alt="logo-rgb" />
        </Link>
        <div className="menu">
          <ul className="nav">
            <li>
              <Link to={`/`}>トップ</Link>
            </li>
            <li id="service">
              <Link to={`/service`}>製品／サービス</Link>
              <div className="submenu-pop">
                <div className="service-mega">
                  <div className="service-mega__sidebar">
                    {serviceCategories.map((category) => (
                      <button
                        type="button"
                        key={category.id}
                        className={`service-mega__sidebar-button ${
                          activeServiceCategory === category.id
                            ? 'is-active'
                            : ''
                        }`}
                        onMouseEnter={() =>
                          activateServiceCategory(category.id)
                        }
                        onClick={() => activateServiceCategory(category.id)}
                        onFocus={(event) =>
                          handleSidebarButtonFocus(event, category.id)
                        }
                      >
                        {category.label}
                      </button>
                    ))}
                  </div>
                  <div className="service-mega__panel">
                    {hasTopLinkTarget ? (
                      <Link
                        to={topLink.to}
                        className="service-mega__panel-top-link"
                      >
                        <span>{topLink.label}</span>
                        <span
                          className="service-mega__panel-top-arrow"
                          aria-hidden="true"
                        />
                      </Link>
                    ) : topLink ? (
                      <span className="service-mega__panel-top-label">
                        {topLink.label}
                      </span>
                    ) : (
                      <span className="service-mega__panel-top-label">
                        {activeCategory.label}
                      </span>
                    )}
                    <div className="service-mega__items solid-height">
                      {activeCategory?.items?.map((item) => (
                        <ServiceMenuItem
                          key={`${item.label}-${
                            item.to || item.href || 'noop'
                          }`}
                          item={item}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <Link to={`/about/`}>会社概要</Link>
            </li>
            <li>
              <Link to={`/contact`}>お問い合わせ</Link>
            </li>
            <li>
              <a
                href="https://herp.careers/v1/itec"
                target="_blank"
                rel="noreferrer"
              >
                採用情報
              </a>
            </li>
          </ul>
          <div className="box login">
            <Link to={`/login/`}>会員向けログイン</Link>
          </div>
          <icon
            id="menu"
            className="sp-only"
            onClick={(e) => {
              setIsDrawerOpen(!isDrawerOpen)
            }}
          />
        </div>
      </div>

      <div id="sp-gnav" className={isDrawerOpen ? 'show' : ''}>
        <div className="gnav-header">
          <Link to={`/`} onClick={handleDrawerItemClick}>
            <img src="/assets/images/common/logo-rgb.png" alt="logo-rgb" />
          </Link>
          <ContactButton onClick={handleDrawerItemClick} />
          <icon
            id="gnav-close"
            onClick={(e) => {
              setIsDrawerOpen(!isDrawerOpen)
            }}
          ></icon>
        </div>
        <div className="inner">
          <ul>
            <li>
              <Link to={`/`} onClick={handleDrawerItemClick}>
                トップページ
              </Link>
            </li>
            <li>
              <Link to={`/login`} onClick={handleDrawerItemClick}>
                会員向けログイン
              </Link>
            </li>
            <li>
              <Link to={`/news`} onClick={handleDrawerItemClick}>
                トピックス
              </Link>
            </li>
            <SlideToggle
              collapsed
              render={({ toggle, setCollapsibleElement, toggleState }) => (
                <div className="my-collapsible">
                  <li
                    className={`parent has-child ${
                      isSlideOpen(toggleState) ? 'open' : ''
                    }`}
                    onClick={toggle}
                    aria-hidden="true"
                  >
                    製品／サービス
                  </li>
                  <div
                    className={`my-collapsible__content ${
                      isSlideOpen(toggleState) ? 'open' : ''
                    }`}
                    ref={setCollapsibleElement}
                  >
                    <div className="my-collapsible__content-inner">
                      <div
                        className={`child ${
                          isSlideOpen(toggleState) ? 'open' : ''
                        }`}
                      >
                        {serviceCategories.map((category) => (
                          <SlideToggle
                            key={category.id}
                            collapsed
                            render={({
                              toggle: toggleCategory,
                              setCollapsibleElement:
                                setCategoryCollapsibleElement,
                              toggleState: categoryToggleState,
                            }) => (
                              <div className="child-category-group">
                                <div
                                  className={`child-category has-child ${
                                    isSlideOpen(categoryToggleState)
                                      ? 'open'
                                      : ''
                                  }`}
                                  onClick={toggleCategory}
                                  aria-hidden="true"
                                >
                                  {category?.topLink &&
                                  typeof category.topLink.to === 'string' &&
                                  category.topLink.to.trim() ? (
                                    <Link
                                      to={category.topLink.to}
                                      onClick={(event) => {
                                        event.stopPropagation()
                                        handleDrawerItemClick()
                                      }}
                                    >
                                      {category.topLink.label || category.label}
                                    </Link>
                                  ) : (
                                    category.label
                                  )}
                                </div>
                                <div
                                  className={`child-items ${
                                    isSlideOpen(categoryToggleState)
                                      ? 'open'
                                      : ''
                                  }`}
                                  ref={setCategoryCollapsibleElement}
                                >
                                  {category.items.map((item) => (
                                    <MobileServiceMenuItem
                                      key={`${category.id}-${item.label}-${
                                        item.to || item.href || 'noop'
                                      }`}
                                      item={item}
                                      onClick={handleDrawerItemClick}
                                    />
                                  ))}
                                </div>
                              </div>
                            )}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            />
            <li>
              <Link to={`/about`} onClick={handleDrawerItemClick}>
                会社概要
              </Link>
            </li>
            <li>
              <Link to={`/mvv`} onClick={handleDrawerItemClick}>
                ミッション・ビジョン・バリュー
              </Link>
            </li>
            <li>
              <Link to={`/faq`} onClick={handleDrawerItemClick}>
                よくあるご質問
              </Link>
            </li>
            <li>
              <Link to={`/contact`} onClick={handleDrawerItemClick}>
                お問い合わせ
              </Link>
            </li>
            <li>
              <a
                href="https://herp.careers/v1/itec"
                target="_blank"
                rel="noreferrer"
                onClick={handleDrawerItemClick}
              >
                採用情報
              </a>
            </li>
            <li>
              <Link to={`/sitemap`} onClick={handleDrawerItemClick}>
                サイトマップ
              </Link>
            </li>
            <li>
              <a
                href="/assets/files/privacy.pdf"
                target="_blank"
                onClick={handleDrawerItemClick}
              >
                個人情報・訂正・削除依頼書
              </a>
            </li>
            <li>
              <Link to={`/policy`} onClick={handleDrawerItemClick}>
                プライバシーポリシー
              </Link>
            </li>
            <li>
              <Link to={`/infosec`} onClick={handleDrawerItemClick}>
                情報セキュリティ基本方針
              </Link>
            </li>

            <li>
              <Link
                to={`/service/qtnetservice/`}
                onClick={handleDrawerItemClick}
              >
                QT-net
              </Link>
            </li>
            <li>
              <a
                href="http://www.i-tech-corp.co.jp/parksearch_pc"
                target="_blank"
                rel="noreferrer"
                onClick={handleDrawerItemClick}
              >
                QT-net駐車場検索
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}

export default Header
